// Recuperer les info de l'instance pour certains champs
const userInfo = JSON.parse(localStorage.getItem("user"));

// Nom du user pour remplir representative
const userName = `${userInfo?.firstname} ${userInfo?.lastname}`

const emptyDataSDME = {
  id: null,
  UserId: null,
  productName: "SDME",
  productId: "2",
  phoneNumber: null,
  quoteCode: null,
  projectNumber: null,
  quoteDate: null,
  isActive: true,
  quotationStatus: "Active",
  estimativeShippingDate: new Date(),
  unitaryPriceCDN: null,
  unitaryPriceUSD: null,
  unitDesignation: null,
  numberUnits: 1,
  exchangeRate: null,
  shipping: "Not Included",
  representative: userName,
  ///////////// CHAMPS PROPRE À SDME /////////////
  airFlowType: "Single Volume",
  CFMHighVolume: null, 
  CFMMinVolume: null, 
  installation: "Outdoor", 
  temperatureRise: "90",
  externalStaticPressure: "1",
  gasType: "Natural",
  gasTrainType: "Standard", 
  dischargeLocation: "Horizontal End", 
  motorSecurityFactor: "1.10", 
  voltage: "575 / 3 / 60", 
  controls: "Included", 
  doubleReversedInterlock: "Not Included", 
  adjustablePrePurge: "Not Included", 
  dirtyFilterContact: "Not Included", 
  disconnectSwitch: "Not Included", 
  roomOverrideStat: "Not Included", 
  ////////////////////////////////////////////////
  shipping: "Not Included",
  country: null,
  province: null,
  city: null,
  startUp: "Not Included",
  unitModel: null,
  mechanicalCode: null,
  margin: 0,
  leadTime: null,
  curbDrawing: null,
  electricalDiagram: null,
  unitaryPrice: null,
  unitaryShippingPrice: null,
  unitaryStartUpPrice: null,
  totalUnitaryPrice: null,
  isPriceValid: false,
  userCreation: null,
  dateCreation: new Date(),
  userModification: null,
  projectNumber: null,
  dateModification: new Date(),
  };

export default emptyDataSDME;

  
  